import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: ${props => props.width || '100%'};
`;

const CategoryItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  color: var(--text-primary);
  text-decoration: none;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    background: var(--glass-2);
    border-color: var(--accent);
    transform: translateX(4px);
  }

  svg {
    width: 16px;
    height: 16px;
    color: var(--text-muted);
  }
`;

const CountBadge = styled.span`
  background: rgba(255,255,255,0.05);
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  color: var(--text-muted);
`;

const CategoryListWidget = ({ node }) => {
  const categoriesRaw = node.content?.categories || "News:12,O2 Business:8,Technologie:24,Corporate:5";
  
  const categories = categoriesRaw.split(',').map(c => {
    const [name, count] = c.split(':');
    return { name: name?.trim() || 'Kategorie', count: count?.trim() || '0' };
  });

  return (
    <Wrapper width={node.style?.desktop?.width}>
      <h4 style={{margin: '0 0 10px 0', fontSize: '16px', color: 'var(--text-primary)'}}>
        {node.content?.title || 'Kategorien'}
      </h4>
      {categories.map((cat, i) => (
        <CategoryItem key={i}>
          <div style={{display:'flex', alignItems:'center', gap: '8px'}}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"></path></svg>
            <span style={{fontWeight: 500}}>{cat.name}</span>
          </div>
          <CountBadge>{cat.count}</CountBadge>
        </CategoryItem>
      ))}
    </Wrapper>
  );
};

registry.register('category_list', {
  label: 'Kategorien Liste',
  icon: '📁',
  category: 'dynamic',
  defaultContent: { title: 'Alle Kategorien' },
  defaultStyle: { desktop: { width: '100%' } },
  render: CategoryListWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Daten', fields: [{name:'content.title', label:'Titel', type:'text'}, {name:'content.categories', label:'Kategorien (Name:Anzahl)', type:'textarea'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.width', label:'Breite', type:'text'}] }] }
  ]
});
